

exports.__esModule = true;

var _uiRouter = require('uiRouter');

var _angular = require('angular');

var _squid = require('squid');

require('xo-ui-components/src/tooltip/directive');

require('xo-form-components/src/add-tax-id/directive');

require('xo-page-components/src/value-props/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoAddTaxIdPageComponent', {
    tag: 'xo-add-tax-id-page',
    template: _template2['default'],
    lifecycle: {
        enter: function enter() {
            this.locale = _squid.$locale;
            this.token = _angular.$rootScope.token;
            this.finish = function () {
                return _uiRouter.$state.go('checkout.review');
            };
        }
    }
});


_uiRouter.$state;

_angular.$rootScope;

_squid.$Component;

_squid.$locale;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./pages/xo-add-tax-id/directive.js
// module id = ./pages/xo-add-tax-id/directive.js
// module chunks = 0